var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelDisplayAdSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12.993 0C13.55 0 14 .45 14 1.007v11.986C14 13.55 13.55 14 12.993 14h-2.37L8.994 9.967l1.936-.084c.522-.022.671-.322.376-.686l-.07-.079-5.882-6.082c-.385-.399-.698-.273-.698.282l-.006 8.46c0 .555.333.711.743.35l1.462-1.288L8.132 14H1.007C.45 14 0 13.55 0 12.993V1.007C0 .45.45 0 1.007 0z"
})));
export default SvgChannelDisplayAdSm;